import React, { useState } from 'react'
import { useEffect } from 'react'
import { getUserListAPI } from '../../API/AdminServices'
import Style from './UserList.module.css'
import { ThreeHorseLoading } from 'react-loadingg'
import { separate } from '../../Functions/SeprateThreeNumber'

const UserList = ({showModalHandler}) => {
    const[List,setList]=useState()
    const[username,setUsername]=useState('')
    useEffect(()=>{
        getUserList()
    },[])
    const getUserList=async()=>{
        const data=await getUserListAPI()
        setList(data.users)
    }
    let loadingHandler=null
    if(List===undefined){
        loadingHandler=<div><ThreeHorseLoading/></div>
    }
    else{
        loadingHandler=List.filter(value=>{
            if(value.name===null){
                return null
            }
            else if(value.name.includes(username)){
                return value
            }
            else if(username===''){
                return value
            }
        }
            
        ).map(item=>{
            return(
                <ul key={item.id}  className={Style.ReaportByTime}>
                    <li>   نام کاربر: <p>{item.name}</p></li>
                    <li>شماره کاربر: <a href={`tel:${item.phone}`}>{item.phone}</a></li>
                    <li>ایمیل کاربر: <p>{item.email}</p></li>
                    <li> تعداد سوال: <p>{item.total_question}</p></li>
                    <li> تعداد پاسخ داده شده: <p>{item.total_answer}</p></li>
                    <li> تعداد دوره خریداری شده: <p>{item.total_course}</p></li>
                    <li>  هزینه پرداخت کرده:  <p>{separate(item.total_paid)}</p></li>
                    <li ><p onClick={()=>showModalHandler(item.courses)}> نمایش دوره ها</p></li>
                </ul>
            )
        })
    }
    return (
        <div className={Style.ComponentHolder}>
            <input type={'search'} placeholder='نام کاربر' 
            className={Style.SearchInput} 
            value={username}
            onChange={e=>setUsername(e.target.value)}
            />

               {loadingHandler}
        </div>
    )
}

export default UserList
